import axios from "axios";
import { APIs, getToken, getPremiseId } from "../../utils/worker";
import { getApiMessage } from "./apiMessage";

const parseErrorFromBlob = async (blob) => {
  try {
    const text = await blob.text();
    const json = JSON.parse(text);
    return getApiMessage(json, "Failed to download report");
  } catch (e) {
    return "Failed to download report";
  }
};

export const downloadReconciliationReport = async (reconcileId) => {
  const tokenStr = getToken();
  const token = tokenStr?.startsWith("Bearer ") ? tokenStr.split("Bearer ")[1] : tokenStr;
  const premiseIdStr = getPremiseId();
  const premiseId = premiseIdStr?.startsWith("Bearer ") ? premiseIdStr.split("Bearer ")[1] : premiseIdStr;

  const response = await axios.get(
    `${APIs.baseURL}/hub-reconciliation-service/v1/hub-reconcile/download/${reconcileId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(premiseId ? { "SMCS-PREMISE-ID": premiseId } : {}),
      },
      responseType: "blob",
    }
  );

  const contentType = response.headers["content-type"] || "";
  if (contentType.includes("application/json")) {
    throw new Error(await parseErrorFromBlob(response.data));
  }

  const disposition = response.headers["content-disposition"] || "";
  let fileName = `HubReconcile_${reconcileId}.csv`;
  const match = disposition.match(/filename="?([^";]+)"?/i);
  if (match?.[1]) {
    fileName = match[1].trim();
  }

  const blob = new Blob([response.data], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);

  return fileName;
};

export const getDownloadErrorMessage = async (error) => {
  if (error?.response?.data instanceof Blob) {
    return parseErrorFromBlob(error.response.data);
  }
  return getApiMessage(error?.response?.data || error, "Failed to download report");
};
